import React from 'react';
import { FontAwesomeConfigurations } from '../../../utils/Configuration/FontAwesomeConfiguration';
import JUNOButton, { JUNOButtonProps } from '../JUNOButton';
import './style.scss';
interface JUNOAttendButtonProps extends JUNOButtonProps {
  showLoader: boolean;
  action: any;
  content: any;
  bypassClick?: any;
  onComplete: (action: any) => void;
  onUnComplete: (action: any) => void;
  disabled?: boolean;
  loginReason?: string;
  loaderIcon?: any;
  textStyle?: string;
  overrideText: string;
  overrideTextCompleted: string;
  canUnComplete?: boolean;
  onClickWithActionCompleted?: any;
}

const JUNOAttendButton: React.FC<JUNOAttendButtonProps> = ({ ...props }) => {
  const [loading, setLoading] = React.useState<boolean>(false);

  let buttonText = props.text;
  let points;
  let aLoader;
  let pointsMultiplierImage;

  if (props.showLoader) {
    aLoader = props.loaderIcon || Resources.resources.REMOTE_LOADER;
  }

  if (props.action) {
    points = props.action.XpReward;

    let multTag;
    if (props.content) {
      multTag = props.content.GetFirstTagOfType(CrowdHub_App.TAGTYPE_POINTMULTIPLIER);
    }

    if (multTag) {
      points *= parseFloat(multTag.Data.tag_numberoption);
      points = Math.ceil(points);
    }
    pointsMultiplierImage = getPointsMultiplierImage(multTag);

    const completedText = props.overrideTextCompleted || props.action.State2Lang || 'Attending';
    const unCompletedText = props.overrideText || props.action.State1Lang || 'Attend';
    buttonText = props.action.UserCompleted ? completedText : unCompletedText;
  }

  const clickWrapper = () => {
    if (!loading) {
      handleButtonClick(props, completeAction, setLoading);
    }
  };

  return (
    <button
      className={loading ? 'juno_attend_button_container loading' : 'juno_attend_button_container'}
      onClick={clickWrapper}
      tabIndex={0}
      style={{ border: 'none' }}
      aria-label={`Attend ${props.content.Name}`}
    >
      <JUNOButton
        buttonStyle={props.buttonStyle}
        text={buttonText}
        textStyle={props.textStyle}
        tabIndex={-1}
      ></JUNOButton>
      {props.showLoader && loading && <img className="center_xy loader" src={aLoader.src} alt={aLoader.alt} />}
      {props.action && props.action.UserCompleted && (
        <div id="action_container" className="brand_color_border">
          <div className="action_items_container">
            <div className="action_done brand_color_color">
              <i className={FontAwesomeConfigurations.ICON_CIRCLE_CHECK}></i>
            </div>
          </div>
        </div>
      )}
      {props.action && !props.action.UserCompleted && (
        <div id="action_container" className="brand_color_border">
          <div className="action_items_container">
            <div className="action_text brand_color_color">
              {points}
              <i className={`action_icon ${FontAwesomeConfigurations.ICON_POINTSBOLT}`}></i>
            </div>
          </div>
        </div>
      )}
      {pointsMultiplierImage}
    </button>
  );
};

const onClickHelper = (props: JUNOAttendButtonProps, completeAction, setLoading) => {
  if (props.disabled) {
    return;
  }

  if (typeof props.bypassClick === 'function') {
    props.bypassClick(props.action);
    return;
  }

  if (props.action && !props.action.UserCompleted) {
    completeAction(true, props.action, props.onComplete, props.onUnComplete, setLoading);
  } else {
    if (props.canUnComplete) {
      completeAction(false, props.action, props.onComplete, props.onUnComplete, setLoading);
    } else if (typeof props.onClickWithActionCompleted === 'function') {
      props.onClickWithActionCompleted();
    }
  }
};

const handleButtonClick = (props: JUNOAttendButtonProps, completeAction, setLoading) => {
  if (App.INSTANCE.CurrentUser.IsLoggedIn() == false) {
    App.INSTANCE.loginOrCreate({
      forceLogin: CrowdHub_App.CONFIG.REQUIRE_GLOBAL_LOGIN,
      aOnComplete: () => {
        if (App.INSTANCE.CurrentUser.IsLoggedIn() == true) {
          if (props.content.hasAccess() == false) {
            App.INSTANCE.checkAccessLevel(props.content);
            return;
          } else {
            onClickHelper(props, completeAction, setLoading);
          }
        }
      },
      aMessage: props.loginReason || CrowdHub_App.LANG.LOGINREASON_DEFAULT,
    });
    return;
  } else {
    if (props.content.hasAccess() == false) {
      App.INSTANCE.checkAccessLevel(props.content);
      return;
    } else {
      onClickHelper(props, completeAction, setLoading);
    }
  }
};

const getPointsMultiplierImage = multTag => {
  if (multTag && multTag.Image.length > 0) {
    return (
      <div id="points_multiplier">
        <img src={App.INSTANCE.getImageSrc(multTag.Image)} />
      </div>
    );
  }
};

const completeAction = (complete, action, onComplete, onUnComplete, setLoading) => {
  if (complete) {
    setLoading(true);

    action.Complete(
      action.ContentId,
      function () {
        setLoading(false);
        if (onComplete != null) {
          onComplete(action);
        }
      },
      function (a) {
        setLoading(false);
        var confirmPopup = new ConfirmPopupPanel();
        if (action.Id == CrowdHub_App.ACTION_ATTEND) {
          const message = a.ErrorMessage ? a.ErrorMessage : CrowdHub_App.LANG.WARNING_FULLEVENT;
          confirmPopup.showOkConfirm('', message, null);
        } else {
          confirmPopup.showOkConfirm('An Unexpected Error Occurred', a.toString(), null);
          console.error(a.toString());
        }
      },
      false,
    );
  } else {
    setLoading(true);
    action.UnComplete(action.ContentId, function () {
      setLoading(false);
      if (onUnComplete != null) {
        onUnComplete(action);
      }
    });
  }
};

export default JUNOAttendButton;
